<template>
  <path
    d="M14.6428 63.5481H37.9279"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M14.6428 71H37.9279"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M26.2853 54.2339V37.9343"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M16.9713 28.6204L26.2853 37.9344L35.5993 28.6204"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M11.9359 44.6286C9.16378 42.4731 6.9186 39.715 5.37044 36.5632C3.82228 33.4114 3.01175 29.9486 3.00025 26.4371C2.94204 13.805 13.1001 3.29761 25.7323 3.00654C30.6212 2.89065 35.4224 4.31692 39.4552 7.08307C43.4879 9.84923 46.5474 13.8148 48.1997 18.4175C49.8521 23.0202 50.0133 28.0262 48.6607 32.7257C47.308 37.4252 44.5101 41.5795 40.6638 44.5995C39.8141 45.2562 39.1259 46.0986 38.6517 47.0621C38.1775 48.0257 37.9299 49.0849 37.9278 50.1588V51.9051C37.9278 52.5227 37.6825 53.115 37.2458 53.5516C36.8091 53.9883 36.2169 54.2336 35.5993 54.2336H16.9713C16.3537 54.2336 15.7615 53.9883 15.3248 53.5516C14.8881 53.115 14.6428 52.5227 14.6428 51.9051V50.1588C14.6355 49.0929 14.3884 48.0424 13.9198 47.0851C13.4512 46.1277 12.7731 45.2882 11.9359 44.6286V44.6286Z"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      required: false,
      default: "black",
    },
    iconBorder: {
      type: String,
      required: false,
      default: "black",
    },
  },
};
</script>

<style scoped>
  path {
    font-family: var(--iconFontFamily);
    font-size: var(--iconFontSize);
    stroke:var(--iconColor)
  }
  .group:hover .group-hover\:text-hoverIcon  path{
    stroke:var(--iconHoberColor)
  }
</style>